import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { DeviceStatus } from "../vars";
import { AlertCircle, TrendingUp, TrendingDown } from "lucide-react";

function DisconnectedDevicesBox({ value, percentage }) {

    const history = useHistory();

    const onBoxClick = () => {
        history.push(`/devices?pageTitle=Disconnected Devices&f_status=${DeviceStatus.DISCONNECTED}`);
    }

    // Logic: Increase (+) in disconnected is BAD (Danger). Decrease (-) is GOOD (Success).
    const isIncrease = percentage && percentage.includes("+");
    const isDecrease = percentage && percentage.includes("-");

    return (
        <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="oct_info-box-v2 variant-disconnected" onClick={() => onBoxClick()}>
                <div className="oct_info-box-corner-v2"></div>

                <div className="oct_info-box-content-v2">
                    <div className="oct_info-box-text-content-v2">
                        <span className="oct_info-box-title-v2">Disconnected Devices</span>

                        <div data-toggle="tooltip" title="Number of disconnected devices">
                            <span className="oct_info-box-number-v2">
                                {value === 0 ? value : value || <div className="dot-flashing ml-3 mt-1" />}
                            </span>
                        </div>

                        <div className="oct_info-box-footer-v2">
                            {
                                percentage && isIncrease ? (
                                    <div className="d-flex align-items-center" data-toggle="tooltip"
                                        title={`Number of disconnected devices has increased by ${percentage}%`}>
                                        <TrendingUp className="trend-icon text-danger" />
                                        <span className="trend-text danger">{percentage}%</span>
                                        <span className="trend-label">Since last day</span>
                                    </div>
                                ) : percentage && isDecrease ? (
                                    <div className="d-flex align-items-center" data-toggle="tooltip"
                                        title={`Number of disconnected devices has decreased by ${percentage}%`}>
                                        <TrendingDown className="trend-icon text-success" />
                                        <span className="trend-text success">{percentage}%</span>
                                        <span className="trend-label">Since last day</span>
                                    </div>
                                ) : (
                                    <div className="d-flex align-items-center" data-toggle="tooltip"
                                        title={`Number of disconnected devices didn't change`}>
                                        {/* <Minus className="trend-icon text-info" /> */}
                                        <span className="trend-text info">{percentage || "0%"}</span>
                                        <span className="trend-label">Since last day</span>
                                    </div>
                                )
                            }
                        </div>
                    </div>

                    <div className="oct_info-box-icon-container-v2">
                        <AlertCircle />
                    </div>
                </div>
            </div>
        </div>
    )

}

export default connect()(DisconnectedDevicesBox);
